export const NEWEST_SHARED_DEPS_CONFIG = "2";

export const SHARED_IMPORTS = {
  [NEWEST_SHARED_DEPS_CONFIG]: {
    scripts: {
      imports: {
        vue: `/libs/shared/vue@3.4.27/dist/${process.env.GUAC_VUE_RUNTIME_LIB}`,
        "vue-router": "/libs/shared/vue-router@4.3.2/dist/vue-router.global.prod.js",
        vuetify: "/libs/shared/vuetify@3.6.4/dist/vuetify.min.js",
        pinia: "/libs/shared/pinia@2.1.7/dist/pinia.iife.prod.js",
        "vue-demi": "/libs/shared/vue-demi@0.14.7/lib/index.iife.js",
        autobahn: "/libs/shared/autobahn@22.11.1/lib/autobahn.js",
        "vue-i18n": "/libs/shared/vue-i18n@9.6.5/dist/vue-i18n.global.prod.js",
        "@getwell/guac-layout": `${process.env.GUAC_APPS_URL}/guac-layout/mf/index.js`,
      },
    },
    styles: ["/libs/shared/vuetify@3.6.4/dist/vuetify.min.css"],
  },
  legacy: {
    scripts: {
      imports: {
        vue: `/libs/shared/vue@3.3.4/dist/${process.env.GUAC_VUE_RUNTIME_LIB}`,
        "vue-router": "/libs/shared/vue-router@4.2.4/dist/vue-router.global.prod.js",
        vuetify: "/libs/shared/vuetify@3.3.8/dist/vuetify.min.js",
        pinia: "/libs/shared/pinia@2.1.4/dist/pinia.iife.prod.js",
        "vue-demi": "/libs/shared/vue-demi@0.14.5/lib/index.iife.js",
        autobahn: "/libs/shared/autobahn@22.11.1/lib/autobahn.js",
        "vue-i18n": "/libs/shared/vue-i18n@9.6.5/dist/vue-i18n.global.prod.js",
        "@getwell/guac-layout": `${process.env.GUAC_APPS_URL}/guac-layout-legacy/mf/index.js`,
      },
    },
    styles: ["/libs/shared/vuetify@3.3.8/dist/vuetify.min.css"],
  },
};
